module.exports = __webpack_public_path__ + "assets/img/ban1.a59d0dcc.jpg";